import React, { useState } from "react";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Button from "@mui/material/Button";
import Checkbox from "@mui/material/Checkbox";
import Typography from "@mui/material/Typography";
import FormControlLabel from "@mui/material/FormControlLabel";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import useStore from "../../store";
import { useNavigate } from "react-router-dom";
import swal from "sweetalert2";
import styles from "./Modal.module.css";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  borderRadius: "10px",
  boxShadow: 24,
  p: 4,
  color: "#000",
  display: "block",
  float: "left",
};

const ModalCompare = () => {
  const navigate = useNavigate();
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [checkedValue, setCheckedValue] = useState([]);
  const setModal = useStore((state) => state.setIsModal);
  const open = useStore((state) => state.isModal);
  const { execute } = useStore((state) => state);
  const startDateLocale = moment(startDate).format("YYYY-MM-DD HH:mm:ss");
  const endDateLocale = moment(endDate).format("YYYY-MM-DD HH:mm:ss");

  const handleChange = (event) => {
    const { value, checked } = event.target;
    if (checked) {
      setCheckedValue((item) => [...item, value]);
    }
  };
  const handleSubmit = async () => {
    await execute(
      `${process.env.REACT_APP_API_SERVER_URL}/tv/detail/multiple`,
      {
        station_name: checkedValue,
        start_date: startDateLocale,
        end_date: endDateLocale,
      }
    );
    setModal();
    swal.fire({
      text: "success",
      icon: "success",
      timer: 1000,
      showCancelButton: false,
      showConfirmButton: false,
    });
    navigate("/compare-data");
  };
  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={setModal}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <Box sx={style}>
            <Box sx={{ px: 3 }}>
              <FormControlLabel
                onChange={handleChange}
                control={<Checkbox />}
                value="Trans7"
                label="Trans 7"
                inputprops={{ "aria-label": "controlled" }}
              />
              <FormControlLabel
                onChange={handleChange}
                control={<Checkbox />}
                value="TRANS TV"
                label="Trans TV"
                inputprops={{ "aria-label": "controlled" }}
              />
              <FormControlLabel
                onChange={handleChange}
                control={<Checkbox />}
                value="SCTV"
                label="SCTV"
                inputprops={{ "aria-label": "controlled" }}
              />
              <FormControlLabel
                onChange={handleChange}
                control={<Checkbox />}
                value="Indosiar"
                label="Indosiar"
                inputprops={{ "aria-label": "controlled" }}
              />
              <FormControlLabel
                onChange={handleChange}
                control={<Checkbox />}
                value="Metro TV"
                label="Metro TV"
                inputprops={{ "aria-label": "controlled" }}
              />
              <FormControlLabel
                onChange={handleChange}
                control={<Checkbox />}
                value="NET TV"
                label="NET TV"
                inputprops={{ "aria-label": "controlled" }}
              />
              <FormControlLabel
                onChange={handleChange}
                control={<Checkbox />}
                value="TvOne"
                label="TV One"
                inputprops={{ "aria-label": "controlled" }}
              />
              <FormControlLabel
                onChange={handleChange}
                control={<Checkbox />}
                value="ANTV"
                label="ANTV"
                inputprops={{ "aria-label": "controlled" }}
              />
              <FormControlLabel
                onChange={handleChange}
                control={<Checkbox />}
                value="Kompas TV"
                label="Kompas TV"
                inputprops={{ "aria-label": "controlled" }}
              />
              <FormControlLabel
                onChange={handleChange}
                control={<Checkbox />}
                value="TVRI"
                label="TVRI"
                inputprops={{ "aria-label": "controlled" }}
              />
            </Box>
            <Box sx={{ m: 2 }}>
              <Box sx={{ p: 1 }}>
                <Typography>Start Date</Typography>
                <DatePicker
                  selected={
                    startDate ? startDate : new Date().setHours(0, 0, 0)
                  }
                  onChange={(date) => setStartDate(date)}
                  showTimeSelect
                  timeFormat="HH:mm"
                  timeIntervals={15}
                  timeCaption="time"
                  dateFormat="MMMM d, yyyy h:mm aa"
                  maxDate={new Date()}
                  className={styles.datepicker}
                />
              </Box>
              <Box sx={{ p: 1 }}>
                <Typography>End Date</Typography>
                <Box>
                  <DatePicker
                    selected={endDate ? endDate : new Date()}
                    onChange={(date) => setEndDate(date)}
                    showTimeSelect
                    timeFormat="HH:mm"
                    timeIntervals={15}
                    timeCaption="time"
                    dateFormat="MMMM d, yyyy h:mm aa"
                    maxDate={new Date()}
                    className={styles.datepicker}
                  />
                </Box>
              </Box>
              <Box sx={{ p: 1 }}>
                <Button
                  onClick={handleSubmit}
                  variant="outlined"
                  sx={{ my: 2 }}
                >
                  Send
                </Button>
              </Box>
            </Box>
          </Box>
        </Fade>
      </Modal>
    </div>
  );
};

export default ModalCompare;
